export const SET_LANGUAGE = 'SET_LANGUAGE';
